<template>
  <div class="rounded-lg overflow-hidden box-border w-full animate-pulse">
    <div class="scrollable-table-container" :style="tableStyle">
      <table
        class="w-full px-2 relative"
        style="border-collapse: separate; border-spacing: 0 16px"
      >
        <thead>
          <tr>
            <th
              v-for="index in headers.length"
              :key="index"
              :class="headerClasses"
            ></th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr v-for="rowIndex in 5" :key="rowIndex" class="rounded-lg">
            <td
              v-for="colIndex in headers.length"
              :key="colIndex"
              :class="cellClasses"
            ></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonPodiumPlacementTable',
  props: {
    headers: {
      type: Array,
      default: () => ['Top', 'Nome', 'Vendas Pagas', 'Valor 1⁠ª Parcela'],
    },
  },
  computed: {
    tableStyle() {
      return {
        maxHeight: '100%',
        overflowY: 'auto',
      };
    },
    headerClasses() {
      return 'p-4 text-xs sm:text-sm md:text-base text-center bg-gray-300 rounded h-8';
    },
    cellClasses() {
      return 'px-6 py-4 text-xs sm:text-sm md:text-base text-center bg-gray-200 h-8 rounded';
    },
  },
};
</script>

<style scoped>
.bg-gray-200 {
  background-color: #e2e8f0;
}
.bg-gray-300 {
  background-color: #cbd5e0;
}
.scrollable-table-container {
  display: block;
  max-height: 100%;
  overflow-y: auto;
  scrollbar-color: #114880 transparent;
  scrollbar-width: thin;
}
</style>
